import {
    GET_WISHLIST,
    GET_WISHLIST_SUCCESS,
    GET_WISHLIST_ERROR,
    ADD_TO_WISHLIST,
    ADD_TO_WISHLIST_ERROR,
    ADD_TO_WISHLIST_SUCCESS,
    REMOVE_FROM_WISHLIST,
    REMOVE_FROM_WISHLIST_SUCCESS,
    REMOVE_FROM_WISHLIST_ERROR
} from '../../actions'

const initialState = {
    total_items: undefined,
    loading: false,
    errorMessage: undefined,
    wishlistItems: {}
}

const cart = (state = initialState, action) => {
    switch (action.type) {
        case GET_WISHLIST:
            return {
                ...state,
                loading: true
            };
        case GET_WISHLIST_SUCCESS:
            return {
                ...state,
                ...action.payload,
                errorMessage: undefined,
                loading: false
            };
        case GET_WISHLIST_ERROR:
            return {
                ...initialState,
                errorMessage: "Unable to load wishlist",
            };
        case ADD_TO_WISHLIST:
        case REMOVE_FROM_WISHLIST:
            return {
                ...state,
                wishlistItems: {
                    ...state.wishlistItems,
                    [action.payload.sku]: {
                        simpleSku: action.payload.simpleSku,
                        state: action.type === ADD_TO_WISHLIST ? 'adding' : 'removing',
                        message: ''
                    }
                },
            }
        case ADD_TO_WISHLIST_ERROR:
        case REMOVE_FROM_WISHLIST_ERROR:
            return {
                ...state,
                wishlistItems: {
                    ...state.wishlistItems,
                    [action.payload.sku]: {
                        ...state.wishlistItems[action.payload.sku],
                        state: 'error',
                        message: 'Error'
                    }
                },
            }
        case ADD_TO_WISHLIST_SUCCESS:
            return {
                ...state,
                wishlistItems: {
                    ...state.wishlistItems,
                    [action.payload.sku]: {
                        ...state.wishlistItems[action.payload.sku],
                        state: 'added',
                        message: ''
                    }
                }
            }
        case REMOVE_FROM_WISHLIST_SUCCESS:
            return {
                ...state,
                wishlistItems: {
                    ...state.wishlistItems,
                    [action.payload.sku]: undefined
                }
            }
        default:
            return state
    }
}

export default cart



// WEBPACK FOOTER //
// ./src/reducers/account/wishlist.js